import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import {
  Button,
  CompanyPage,
} from "../../../components/common";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch, useSelector } from "react-redux";
import { saveImportedContactsRequest } from "../../../reducers/company/companyMarketingSolution.reducer";
import { rootReducersState } from "../../../reducers";
import StatusModal from "./statusModal";
import appRoutes from "../../../routes/app.routes";
import { useNavigate } from "react-router-dom";

const ReviewInfo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { parsedContacts, tags, loading, flag, subscription_status } =
    useSelector(
      ({ company }: rootReducersState) => company.companyMarketingSolution
    );
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const companySlug = sessionReducer.currentCompany.slug;

  const handleContinue = () => {
    const formData = new FormData();
    formData.append("contacts", JSON.stringify(parsedContacts));
    formData.append("tags", JSON.stringify(tags));
    formData.append("is_subscribe", subscription_status);
    dispatch(saveImportedContactsRequest(formData));
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    navigate(appRoutes.contactList.generatePath(companySlug));
  };
 
  return (
    <>
      <CompanyPage
        className="page-marketing"
        title="Review and complete your import contact information"
        footer={
          <CompanyPage.FooterActions>
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button onClick={handleContinue} loading={loading}>
              Continue
            </Button>
          </CompanyPage.FooterActions>
        }
      >
          <List className="list-wrapper">
            <ListItem dense>
              <ListItemIcon>
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText primary="Imported from: File upload" />
            </ListItem>
            <ListItem dense>
              <ListItemIcon>
                {subscription_status ? <CheckCircleIcon /> : <CancelIcon />}
              </ListItemIcon>
              <ListItemText
                primary={`Email Marketing Status: ${
                  subscription_status ? "Subscribe" : "Unsubscribe"
                }`}
              />
            </ListItem>
            <ListItem dense>
              <ListItemIcon>
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText primary="Update Existing contacts: No" />
            </ListItem>
            <ListItem dense>
              <ListItemIcon>
                <CheckCircleIcon fill="#FF0990" />
              </ListItemIcon>
              <ListItemText primary="Tagged: Member" />
            </ListItem>
          </List>
      </CompanyPage>
      {!loading && flag && isOpen && (
        <StatusModal open={isOpen} handleClose={handleClose} />
      )}
    </>
  );
};

export default ReviewInfo;
